import { Component, OnInit } from "@angular/core";
import { Title } from "@angular/platform-browser";
import { ActivatedRoute } from "@angular/router";

declare var $: any;
declare var defaultGridEditSettings: any;

@Component({
  selector: "account-groups",
  templateUrl: "./account-groups.component.html",
  styleUrls: ["./account-groups.component.css"],
})
export class AccountGroupsBranch implements OnInit {
  constructor(private route: ActivatedRoute, private titleService: Title) {}

  ngOnInit() {
    //Set the page title
    this.titleService.setTitle("WiseRisk | Account Group Settings");

    /*<![CDATA[*/
    var mainNav = "setting-nav";
    var sideNav = "side-nav-setting-account-grp";

    $(document).ready(function () {
      var source = {
        datatype: "json",
        datafields: [
          {
            name: "accountGroupCode",
            type: "string",
          },
          {
            name: "displayName",
            type: "string",
          },
          {
            name: "organizationId",
            type: "string",
          },
          {
            name: "externalAccountGroupId",
            type: "string",
          },
          {
            name: "accountGroupId",
            type: "string",
          },
        ],
        id: "accountGroupId",
        url: "/ajax/account-groups",
        type: "GET",
        async: true,
      };
      var settings = defaultGridEditSettings("#jqxgrid", source);
      settings.columns = [
        {
          text: "Account Group Code",
          columntype: "textbox",
          datafield: "accountGroupCode",
          width: "25%",
        },
        {
          text: "Display Name",
          columntype: "textbox",
          datafield: "displayName",
          width: "40%",
        },
        {
          text: "Organization Id",
          datafield: "organizationId",
          hidden: true,
        },
        {
          text: "External Account Group Id",
          datafield: "externalAccountGroupId",
          hidden: true,
        },
        {
          text: "accountGroupId",
          datafield: "accountGroupId",
          hidden: true,
        },
      ];
      $("#jqxgrid").jqxGrid(settings);
    });
    /*]]>*/
  }
}



// WEBPACK FOOTER //
// /app/wiserisk-core/src/main/ng4app/src/app/pages/settings/account-groups/account-groups.component.ts